export const paginateArrayElements = (array, pageSize, currentPage) => {
  const startIdx = currentPage * pageSize - pageSize;
  const endIdx = array.length <= currentPage * pageSize ? array.length : currentPage * pageSize;
  return array.slice(startIdx, endIdx);
}